import {RootState} from '../../../store/store';
import {useSelector} from 'react-redux';

function selector(state: RootState) {
    return state.globalCompanyInfo;
}

export function useGlobalCompanyInfo() {
  return useSelector<RootState, ReturnType<typeof selector>>(selector);
}
